import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import TodayDemoData from "./TodayDemoData";
import FIIDIIDemo from "./FIIDIIDemo";
import AdvdecdDemo from "./AdvdecdDemo";
import NewFiftyTwoDemo from "./NewFiftyTwoDemo";
import BlockdealsDemo from "./BlockdealsDemo";
import BulkdealsDemo from "./BulkdealsDemo";
import SectoranalysisDemo from "./SectoranalysisDemo";
import PullCallRatioDataDemo from "./PullCallRatioDataDemo";
import IndiaVixDemo from "./IndiaVixDemo";
import MarketbreadthData from "./MarketbreadthData";
import DerivativeDemo from "./DerivativeDemo";
import FiifnoDemo from "./FiifnoDemo";
import Event from "./EventDemo";
import CorporateAction from "./CorporateActionDemo";
import Common from "./../../common.json";
import MWDATA from "./MWDATADemo";
import Insider from "./InsiderDemo";
import FAQ from "./FAQ";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
});
export default function PriceMarketActivity() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [todayData, settodayData] = useState(false);
  const [commonData, setcommonData] = useState(false);
  useEffect(() => {
    setLoading(true);
    RestService.getCommonDataList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setcommonData(response.data);
        settodayData(response.data.todayData);
      },
      mobile,
      web_token
    );
  }, [mobile, web_token]);

  const Onclicksection = (id) => {
    document.getElementById(id).scrollIntoView(true);
    // now account for fixed header
    var scrolledY = window.scrollY;
    if (scrolledY) {
      window.scroll(0, scrolledY - 180);
    }
  };

  return (
    <>
      <GlobalHelmet {...Common?.marketActivity} />
      {loading ? <Loader /> : ""}
      <nav className="nav-menu addscroller ">
        <ul>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("todayActivity");
              }}
            >
              Today`s Activity
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("fiifiicash");
              }}
            >
              FII/DII Cash
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("advdec");
              }}
            >
              ADV/DEC
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("newwhl");
              }}
            >
              New 52w H/L
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("blockDeals");
              }}
            >
              Block Deals
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("bulkdeals");
              }}
            >
              Bulk Deals
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("SectorAnalysis");
              }}
            >
              Sector Analysis
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("putcall");
              }}
            >
              Put/Call Ratio
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("VIX");
              }}
            >
              VIX
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("MarketBreadth");
              }}
            >
              Market Breadth
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("DERIVATIVE");
              }}
            >
              DERIVATIVE
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("FIIF&O");
              }}
            >
              FII F&O
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("Event");
              }}
            >
              Event
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("CorporateAction");
              }}
            >
              Corporate Action
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("ETF");
              }}
            >
             ETF
            </b>
          </li>
          <li className="">
            <b
              onClick={() => {
                Onclicksection("Insider");
              }}
            >
              Insider
            </b>
          </li>
        </ul>
      </nav>
      <div className="bodycontainer activityContainer">
        <div className="auto-space price-auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="Market Activity" />
              <div className={classes.root}>
                <div className="">
                  <div className="row ">
                    <div className="col-sm-12">
                      <h1 className="h1 highlighttext">Market Activity</h1>
                      <p>
                      Get all the latest share market and India stock market news and updates on money tree robo. Explore the stock market today. Find daily market activity like FII DII activities, FII DII data, FII DII cash, bulk deals, block deals, put call ratio, india vix, advance decline ratio, market breadth, sector analysis, today’s event stocks, corporate action stocks & block deal today, exchange traded funds etc. 
                      </p>
                      <hr />
                    </div>
                    <div className="col-sm-12">
                      <section id="todayActivity" className="about section-bg">
                        <h3>
                          <span className="highlighttext">
                            Today`s Activity
                          </span>
                        </h3>
                        <TodayDemoData todayData={todayData} />
                        <Link
                          to="/fii-dii-data-nse"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="fiifiicash" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext">FII/DII Cash </span>
                        </h3>
                        <FIIDIIDemo
                          fiidii={commonData.fiidii ? commonData.fiidii : []}
                        />
                        <Link
                          to="/fii-dii-activities"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="advdec" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext">ADV/DEC </span>
                        </h3>
                        <AdvdecdDemo
                          getAdvData={
                            commonData.getAdvData ? commonData.getAdvData : []
                          }
                        />
                        <Link
                          to="/advance-decline-ratio-nse"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="newwhl" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext"> New 52w H/L</span>
                        </h3>
                        <NewFiftyTwoDemo
                          newwldata={
                            commonData.newwldata ? commonData.newwldata : []
                          }
                        />
                        <Link
                          to="/new-fifty-two"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="blockDeals" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext"> Block Deals </span>
                        </h3>
                        <BlockdealsDemo
                          getblockData={
                            commonData.getblockData
                              ? commonData.getblockData
                              : []
                          }
                        />
                        <Link
                          to="/block-deals-nse"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="bulkdeals" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext"> Bulk Deals </span>
                        </h3>
                        <BulkdealsDemo
                          getBulkDeal={
                            commonData.getBulkDeal ? commonData.getBulkDeal : []
                          }
                        />
                        <Link
                          to="/bulk-deals-nse"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View Morw
                        </Link>
                      </section>
                      <section id="SectorAnalysis" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext">Sector Analysis</span>
                        </h3>
                        <SectoranalysisDemo
                          getAnalsysData={
                            commonData.getAnalsysData
                              ? commonData.getAnalsysData
                              : []
                          }
                        />
                        <Link
                          to="/sector-analysis"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="putcall" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext">Put/Call Ratio </span>
                        </h3>
                        <PullCallRatioDataDemo
                          getPullCallRatioData={
                            commonData.getPullCallRatioData
                              ? commonData.getPullCallRatioData
                              : []
                          }
                        />
                        <Link
                          to="/put-call-ratio"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="VIX" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext"> VIX</span>
                        </h3>

                        <IndiaVixDemo
                          getIndiaVixRatioData={
                            commonData.getIndiaVixRatioData
                              ? commonData.getIndiaVixRatioData
                              : []
                          }
                        />
                        <Link
                          to="/india-vix"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="MarketBreadth" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext"> Market Breadth</span>
                        </h3>
                        <MarketbreadthData
                          getTodayMarketData={
                            commonData.getTodayMarketData
                              ? commonData.getTodayMarketData
                              : []
                          }
                        />
                        <Link
                          to="/market-breadth-today"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="DERIVATIVE" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext">DERIVATIVE </span>
                        </h3>
                        <DerivativeDemo
                          getDerivativeData={
                            commonData.getDerivativeData
                              ? commonData.getDerivativeData
                              : []
                          }
                        />
                        <Link
                          to="/nse-derivative"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View more
                        </Link>
                      </section>
                      <section id="FIIF&O" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext">FII F&O </span>
                        </h3>
                        <FiifnoDemo
                          getFiiData={
                            commonData.getFiiData ? commonData.getFiiData : []
                          }
                        />
                        <Link
                          to="/fii-futures-data"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section id="Event" className="about section-bg">
                        <hr />
                        <h3>
                          <span className="highlighttext">Event </span>
                        </h3>
                        <Event
                          getEventData={
                            commonData.getEventData
                              ? commonData.getEventData
                              : []
                          }
                        />
                        <Link
                          to="/event"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section
                        id="CorporateAction"
                        className="about section-bg"
                      >
                        <hr />
                        <h3>
                          <span className="highlighttext">
                            Corporate Action
                          </span>
                        </h3>

                        <CorporateAction
                          getActionData={
                            commonData.getActionData
                              ? commonData.getActionData
                              : []
                          }
                        />
                        <Link
                          to="/corporate-action"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section
                        id="ETF"
                        className="about section-bg"
                      >
                        <hr />
                        <h3>
                          <span className="highlighttext">
                          ETF
                          </span>
                        </h3>

                        <MWDATA
                          getActionData={
                            commonData.mwequitiesData
                              ? commonData.mwequitiesData
                              : []
                          }
                        />
                        <Link
                          to="/exchange-traded-funds"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                      <section
                        id="Insider"
                        className="about section-bg"
                      >
                        <hr />
                        <h3>
                          <span className="highlighttext">
                          Insider
                          </span>
                        </h3>
                          <Insider 
                          getActionData={
                            commonData.tradingequitiesData
                              ? commonData.tradingequitiesData
                              : []
                          }
                        />
                        <Link
                          to="/insider-trading"
                          className="btn  mt-2 mr-2 btn-success"
                        >
                          View More
                        </Link>
                      </section>
                    </div>
                    <div className="col-md-12 mt-4" >
                      <FAQ getMData={commonData?.getMData} getAutoSignalData={commonData?.getAutoSignalData} />
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
